import { Order } from '@ui/hooks/trade/useTradeOrders/types';
import { isNil } from 'lodash-es';

import { useGetExecutionFeeUsd } from '../../hooks/useGetExecutionFee';
import { EditTpSlType } from '../../types';
import { TpSlEditButton } from '../TpSlEditButton';
import { useOrderListContext } from './context';
import { toGenericTradeParams } from './utils/toGenericTradeParams';

export const OrderTpSlEditButton = ({
  order,
  children,
}: {
  order: Order;
  children?: React.ReactNode;
}) => {
  const openFeeP = useOrderListContext().feeConfig?.openFeeP;
  const lvTokenDiscountP = useOrderListContext().feeConfig?.lvTokenDiscountP;
  const executionFee = useGetExecutionFeeUsd();

  if (isNil(openFeeP) || isNil(lvTokenDiscountP) || isNil(executionFee)) return null;

  return (
    <TpSlEditButton
      genericTradeParams={toGenericTradeParams({
        order,
        openFeeP,
        lvTokenDiscountP,
        executionFee,
      })}
      type={EditTpSlType.ORDER}
    >
      {children}
    </TpSlEditButton>
  );
};
